import * as actionTypes from './actionTypes'
import {TAction} from './actions'
import {IState} from './model'

const initialState: IState = {
  items: [],
  isFetching: false,
  isRegistrationCodeValid: null
}

const reducer = (state: IState = initialState, action: TAction): IState => {
  switch (action.type) {
    case actionTypes.SET_TECHNICIANS:
      return {
        ...state,
        items: action.payload
      }
    case actionTypes.ADD_TECHNICIANS:
      return {
        ...state,
        items: [...state.items, ...action.payload]
      }
    case actionTypes.REMOVE_TECHNICIAN:
      return {
        ...state,
        items: state.items.filter(i => i.id !== action.payload.id)
      }
    case actionTypes.CLEAR_TECHNICIANS:
      return {
        ...state,
        items: []
      }
    case actionTypes.SET_IS_FETCHING_TECHNICIANS:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.RESET_IS_FETCHING_TECHNICIANS:
      return {
        ...state,
        isFetching: false
      }
    case actionTypes.SET_IS_REGISTRATION_CODE_VALID:
      return {
        ...state,
        isRegistrationCodeValid: action.payload
      }
    case actionTypes.RESET_IS_REGISTRATION_CODE_VALID:
      return {
        ...state,
        isRegistrationCodeValid: null
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/technicians/reducer.ts